import { Component, OnInit } from '@angular/core';
import templateString from './customers.component.html';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CustomerFormComponent } from '../customerForm';
import { DataService } from '../../../data.service';
import { HttpClient } from '@angular/common/http';

@Component({
  standalone: false,
  template: templateString
})
export class CustomersComponent implements OnInit {
    
    public customers: any;
    public customerTypes: string[];
    public invoiceExportMonth: string;

    constructor(
        private http: HttpClient,
        private toastr: ToastrService,
        private bsModalService: BsModalService,
        private dataService: DataService
    ) { }

    refresh() {
        this.http.get("customers").subscribe(x => {
            this.customers = x;

            this.customers.forEach(function(customer) {
                customer.invoicePdfUrl = "/customers/" + customer.id + "/invoice.pdf";
                customer.invoiceEmailUrl = "/customers/" + customer.id + "/invoice_email";
            });
        });
    }

    create() {
        var bsModalRef = this.bsModalService.show(CustomerFormComponent, {
            initialState: {
                customerId: null,
                newId: Math.max(...this.customers.map(function(x) { return x.id })) + 1
            },
            class: 'modal-lg'
        });

        bsModalRef.content.action.subscribe(result => {	
			this.refresh();
        });
    }

    edit(customerId) {
        var bsModalRef = this.bsModalService.show(CustomerFormComponent, {
            initialState: {
                customerId: customerId
            },
            class: 'modal-lg'
        });

        bsModalRef.content.action.subscribe(result => {	
			this.refresh();
        });
    }

    eBoekhoudenExportUrl() {
        return "/customers/invoices_for_e_boekhouden?period=" + this.invoiceExportMonth;
    }

    initialize() {
        this.customerTypes = [
            '', 
            '1. Met opleidingsrooster', 
            '2. Regionale planning',
            '3. Regulier',
            '4. Met individueel gedeelte'
        ]

        var dateOfPeriod = new Date();
        dateOfPeriod.setMonth(dateOfPeriod.getMonth() - 1);
        this.invoiceExportMonth = dateOfPeriod.getFullYear() + "-" + ("0" + (dateOfPeriod.getMonth() + 1)).slice(-2);

        this.refresh();
	}
	
    ngOnInit() {
        this.initialize();
    }
}
